import React from 'react';

const Arrows = ({ className = "" }) => (
  <svg className={className} width="120" height="80" viewBox="0 0 120 80" fill="none">
    <path d="M10 40 L 35 40 M 30 35 L 35 40 L 30 45" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M50 25 L 65 15 M 60 18 L 65 15 L 62 20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M85 50 L 95 65 M 90 62 L 95 65 L 92 70" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

export default Arrows;